import Vue from 'vue';
import $http from '@/http.js';
import router from '../../../router';

export const setCardName = ({ commit }, cardName) => {
  commit('SET_CARD_NAME', cardName);
};

export const setCardCPF = ({ commit }, cardCPF) => {
  commit('SET_CARD_CPF', cardCPF);
};

export const setCardNumber = ({ commit }, cardNumber) => {
  commit('SET_CARD_NUMBER', cardNumber);
};

export const setCardDate = ({ commit }, cardDate) => {
  commit('SET_CARD_DATE', cardDate);
};

export const setCardCVC = ({ commit }, cardCVC) => {
  commit('SET_CARD_CVC', cardCVC);
};

export const clearCardData = ({ commit }) => {
  commit('SET_CARD_NAME', '');
  commit('SET_CARD_CPF', '');
  commit('SET_CARD_NUMBER', '');
  commit('SET_CARD_DATE', '');
  commit('SET_CARD_CVC', '');
  commit('SET_INSTALMENT_AMOUNT', 1);
  commit('SET_INTEREST_AMOUNT', 0);
  commit('SET_TOTAL_AMOUNT', 0);
  commit('SET_INTERESTS', {});
  commit('SET_BILLET', {});
  commit('SET_PAYMENT_DATA', null);
};

export const setInstalmentAmount = ({ commit }, instalmentAmount) => {
  commit('SET_INSTALMENT_AMOUNT', instalmentAmount);
};

export const setInterestAmount = ({ commit }, interestAmount) => {
  commit('SET_INTEREST_AMOUNT', interestAmount);
};

export const setTotalAmount = ({ commit }, totalAmount) => {
  commit('SET_TOTAL_AMOUNT', totalAmount);
};

export const setInterests = ({ commit }, interests) => {
  commit('SET_INTERESTS', interests);
};

export const setBillet = ({ commit }, billet) => {
  commit('SET_BILLET', billet);
};

export const setPaymentData = ({ commit }, data) => {
  commit('SET_PAYMENT_DATA', data);
};

export const fetchPaymentOptions = async (
  { commit, dispatch, getters },
  { eventID, pdv, total, commissioner, disableLoading, partialPayment, coupon }
) => {
  try {
    if (!disableLoading) dispatch('addLoading');
    let value = 0;
    if (commissioner && !partialPayment) {
      if (getters.pendingOrder) value = getters.orderPdvData.valor_pendente;
      else value = getters.totalValueOrder * 100;
    } else value = total;
    const { data } = await $http.get(
      `pdv/event/payment-options/${eventID}/${
        commissioner ? getters.orderPdvData.pdv : pdv
      }/${value}`,
      { params: { cupom: coupon } }
    );
    var paymentOptions = data;
    let eventName = getters.eventName;
    if (
      eventName &&
      eventName.toLowerCase().includes('drive park') &&
      !commissioner
    ) {
      paymentOptions.ame = true;
    }

    let interests = null;
    let billet = null;
    let ame = null;
    let pix = null;
    let paypal = null;
    let paypalPlus = null;
    let invoice = null;
    let totalValue = 0;
    if (commissioner && !partialPayment) {
      if (getters.pendingOrder)
        totalValue = getters.orderPdvData.valor_pendente * 100;
      else totalValue = getters.totalValueOrder * 100;
    } else totalValue = total * 100;
    commit('SET_PAYMENT_DATA', paymentOptions);
    commit('SET_PAYPAL_CLIENT_ID', paymentOptions.paypal_client_id);
    // split_payment_total: getters.pendingOrder ? getters.orderPdvData.valor_pendente : null
    if (paymentOptions.credit_card) {
      totalValue += paymentOptions.transaction_charge_credit * 100;

      const parcelas = [
        {
          text: `1x de ${Vue.options.filters.currency(totalValue)}`,
          value: {
            instalments: 1,
            total: totalValue,
            interestAmount: totalValue,
          },
        },
      ];
      let orderCode =
        getters.body && getters.body.codigo_pedido
          ? getters.body.codigo_pedido
          : '';
      let even = false;
      if (orderCode && orderCode % 2 === 0) {
        even = true;
      }
      for (let i = 2; i <= 12; i++) {
        if (typeof paymentOptions[`credit_card_${i}_value`] !== 'undefined') {
          const value = parseFloat(paymentOptions[`credit_card_${i}_value`]);
          const instalmentText =
            i <= paymentOptions.credit_card_installments_with_no_interest
              ? ''
              : even
              ? `(Com Juros)`
              : `(Juros de ${paymentOptions.credit_card_interest}% a.m.)`;
          parcelas.push({
            text: `${i}x de ${Vue.options.filters.currency(
              value * 100
            )} ${instalmentText}`,
            value: {
              instalments: i,
              total: Math.round(
                parseFloat(paymentOptions[`credit_card_${i}_total`]) * 100
              ),
              interestAmount: Math.round(
                parseFloat(paymentOptions[`credit_card_${i}_value`]) * 100
              ),
            },
          });
        } else {
          break;
        }
      }
      interests = {
        id: 'CC',
        label: 'Cartão de Crédito',
        parcelas,
      };
    }

    if (paymentOptions.billet) {
      billet = {
        id: 'BB',
        label: 'Boleto',
      };
    }

    if (paymentOptions.paypal) {
      paypal = {
        id: 'PP',
        label: 'Paypal',
      };
    }

    if (paymentOptions.paypal_plus) {
      paypalPlus = {
        id: 'PPE',
        label: 'Cartão de Crédito',
      };
    }

    if (paymentOptions.ame_digital) {
      ame = {
        id: 'AME',
        label: 'AME',
      };
    }

    if (paymentOptions.pix) {
      pix = {
        id: 'PIX',
        label: 'Pix',
      };
    }

    if (paymentOptions.invoice) {
      invoice = {
        id: 'INVOICE',
        label: 'Venda Faturada',
      };
    }

    commit('SET_INTERESTS', interests);
    commit('SET_BILLET', billet);
    commit('SET_AME', ame);
    commit('SET_PIX', pix);
    commit('SET_INVOICE_SALE', invoice);
    commit('SET_PAYPAL', paypal);
    commit('SET_PAYPAL_PLUS', paypalPlus);
    dispatch('subtractLoading');
  } catch (err) {
    dispatch('subtractLoading');
    console.error('Failed retrieving payment options', err);
  }
};

export const getPaypalOrderId = async ({
  commit,
  dispatch,
  getters,
  state,
}) => {
  const { productsQuantity } = getters;
  const orderID = getters.body.codigo_pedido;
  const params = {
    customer_name: getters.userProps.name,
    customer_doc: getters.userProps.document,
    customer_email: getters.userProps.email,
    customer_phone: getters.userProps.phone,
    customer_address: getters.userProps.address,
    customer_address_number: getters.userProps.number,
    customer_address_complement: getters.userProps.complement,
    customer_zipcode: getters.userProps.cep,
    customer_neighborhood: getters.userProps.neighborhood,
    customer_city: getters.userProps.city,
    customer_state: getters.userProps.state,
    customer_country: getters.userProps.country,
    delivery_option_id: getters.deliveryOption,
    event_id: getters.eventID,
    installment_amount: 1,
    interest_amount: 0,
    order_id:
      router.history.current.name === 'commissioner'
        ? getters.orderPdvData.codigo_pedido
        : orderID,
    payment_type_id: 7, // Paypal
    products_amount: productsQuantity,
    total:
      router.history.current.name === 'commissioner'
        ? getters.totalValueOrder
        : Math.round(parseFloat(getters.totalAmount)),
    split_payment_total: getters.pendingOrder
      ? getters.orderPdvData.valor_pendente
      : null,
    // pdv: 100,
  };

  if (getters.userProps.email) {
    params.customer_email = getters.userProps.email;
  }

  if (
    (getters.eventName && getters.eventName.includes('Natal Luz')) ||
    getters.checkout_dados_nf === 2
  ) {
    let location =
      getters.userProps && getters.userProps.locationModel
        ? getters.userProps.locationModel.split('/')
        : '';
    params.customer_city = location ? location[0] : '';
    params.customer_state = location ? location[1] : '';
    params.customer_country = location ? location[2] : '';
  }

  if (getters.buyerData.clientID) {
    params.user_id = getters.buyerData.clientID;
  }

  try {
    dispatch('addLoading');
    commit('SET_PAYPAL_ORDER_TOKEN', null);
    const response = await $http.post('orders/charge/digital/paypal', params);

    const { data } = response;

    if (data.status !== 'created') {
      dispatch('openErrorDialog', 'Erro no carregamento da Transação');
      console.log('setPurchaseStarted - getPaypalOrderId 222 - false');
      dispatch('setPurchaseStarted', false);
    } else {
      commit('SET_PAYPAL_ORDER_TOKEN', data.approvalUrl);
    }
    dispatch('subtractLoading');
  } catch (error) {
    const evento = getters.eventID;
    if (error.response && error.response.status === 410) {
      dispatch('openSnackbar', {
        message: 'Pedido Inválido',
      });
      dispatch('deleteCheckoutState', evento);
      dispatch('loadCheckoutState', evento);
      dispatch('resetSelection');
      dispatch('setResetPurchase', false);
    }
    dispatch('subtractLoading');
    console.log('setPurchaseStarted - getPaypalOrderId 240 - false');
    dispatch('setPurchaseStarted', false);
    console.error(`Failed charging card`, error);
  }
};

export const chargeCard = async (
  { commit, dispatch, getters, state },
  pagseguroParams
) => {
  let productsQuantity = 0;
  if (router.history.current.name !== 'commissioner')
    productsQuantity = getters.productsQuantity;
  else {
    getters.orderPdvData.produtos_array.forEach(p => {
      productsQuantity += p.quantidade;
    });
  }
  const orderID = getters.body.codigo_pedido;
  let splitedPayment = 0;
  if (getters.pendingOrder) splitedPayment = getters.partialValue;
  else if (getters.paymentData && getters.paymentData.split_payment)
    splitedPayment = getters.partialValue;
  else splitedPayment = null;
  let params = {
    opt_in: getters.optIn,
    card_number: pagseguroParams ? '1' : getters.cardNumber,
    card_name: getters.cardName,
    card_expiration: pagseguroParams ? '1' : getters.cardDate,
    card_cvv: pagseguroParams ? '1' : getters.cardCVC,
    // customer_name: getters.buyerData.name,
    customer_name: getters.userProps.name,
    customer_doc: getters.userProps.document,
    customer_email: getters.userProps.email,
    customer_phone: getters.userProps.phone,
    customer_address: getters.userProps.address,
    customer_address_number: getters.userProps.number,
    customer_address_complement: getters.userProps.complement,
    customer_zipcode: getters.userProps.cep,
    customer_neighborhood: getters.userProps.neighborhood,
    customer_city: getters.userProps.city,
    customer_state: getters.userProps.state,
    customer_country: getters.userProps.country,
    delivery_option_id: getters.deliveryOption,
    event_id: getters.eventID,
    installment_amount: getters.instalmentAmount.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false,
    }),
    interest_amount: getters.productsTotal * 100,
    order_id:
      router.history.current.name === 'commissioner'
        ? getters.orderPdvData.codigo_pedido
        : orderID,
    payment_type_id: 1, // Crédito
    products_amount: productsQuantity,
    total:
      router.history.current.name === 'commissioner'
        ? getters.totalValueOrder * 100
        : getters.productsTotal * 100,
    split_payment_total: splitedPayment,
    // pdv: 100,
    coupon: getters.cupomCode || '',
  };
  if (getters.userProps.email) {
    params.customer_email = getters.userProps.email;
  }

  if (
    (getters.eventName && getters.eventName.includes('Natal Luz')) ||
    getters.checkout_dados_nf === 2
  ) {
    let location =
      getters.userProps && getters.userProps.locationModel
        ? getters.userProps.locationModel.split('/')
        : '';
    params.customer_city = location ? location[0] : '';
    params.customer_state = location ? location[1] : '';
    params.customer_country = location ? location[2] : '';
  }

  if (getters.buyerData.clientID) {
    params.user_id = getters.buyerData.clientID;
  }
  if (pagseguroParams) {
    params = Object.assign(params, pagseguroParams);
  }

  try {
    dispatch('addLoading');
    let headers = { checkout: 'one-checkout' };
    const response = await $http.post('pdv/orders/charge/card', params, {
      headers,
    });

    const { data } = response;
    commit('SET_ORDER_DATA', data);
    if (data.status === 'DECLINED') {
      dispatch('openSnackbar', {
        message: data.message,
      });
    }
    if (data.status !== 'paid' && data.status !== 'in_process') {
      if (data.status === 'refused' && data.message)
        dispatch('openErrorDialog', data.message);
      else if (data.status === '3ds') return data;
      else dispatch('openErrorDialog', 'Transação recusada');
      console.log('setPurchaseStarted - chargeCard 297 - false');
      dispatch('setPurchaseStarted', false);
    } else if (!data.payables.length) {
      dispatch('openErrorDialog', 'Erro na transação, ');
      console.log('setPurchaseStarted - chargeCard 301 - false');
      dispatch('setPurchaseStarted', false);
    } else {
      const postOrder = {
        ...getters.postOrder,
        ddi: params.ddi,
        ddd: params.ddd,
        phone: params.phone,
        email: params.customer_email,
        organizador: data.orderData ? data.orderData.nome_organizador : '',
        cpf_organizador: data.orderData ? data.orderData.org_cpf : '',
        cnpj_organizador: data.orderData ? data.orderData.org_cnpj : '',
        mensagem: data.orderData
          ? data.orderData.mensagem_conclusao_pedido
          : '',
        status: data.status === 'paid' ? 'Aprovado' : 'Em análise',
        card: ` no cartão terminado em ${getters.cardNumber.substr(
          getters.cardNumber.length - 4
        )}`,
        instalments: `em ${getters.instalmentAmount}x`,
        hash_pedido: getters.body.hash_pedido,
        payment: state.paymentOption,
      };

      dispatch('setPostOrder', postOrder);
      dispatch('setBody', {
        ...getters.body,
        expiration: 0,
      });
      // dispatch('confirmOrder');
      console.log('PASSEI AQUI');
      commit('SET_TICKET_URL', data.orderData ? data.orderData.ticketsUrl : '');
      console.log('setPurchaseStarted - chargeCard 332 - false');
      dispatch('setPurchaseStarted', false);
      dispatch('nextStep');
    }
    dispatch('subtractLoading');
  } catch (error) {
    const evento = getters.eventID;
    console.log('error.response', error.response);
    if (error.response && error.response.status === 412) {
      dispatch('openSnackbar', {
        message: error.response.data.message,
      });
    }
    if (error.response && error.response.status === 422) {
      dispatch('openSnackbar', {
        message:
          'Seu pedido foi cancelado por excesso de tentativas de pagamento.',
        extraButton: true,
      });
    }
    if (error.response && error.response.status === 410) {
      dispatch('openSnackbar', {
        message: 'Pedido Inválido',
      });
      dispatch('deleteCheckoutState', evento);
      dispatch('loadCheckoutState', evento);
      dispatch('resetSelection');
      dispatch('setResetPurchase', false);
    }
    dispatch('subtractLoading');
    console.log('setPurchaseStarted - chargeCard 349 - false');
    dispatch('setPurchaseStarted', false);
    console.error(`Failed charging card`, error);
  }
};

export const chargeInvoice = async (
  { commit, dispatch, getters, state },
  pagseguroParams
) => {
  let productsQuantity = 0;
  if (router.history.current.name !== 'commissioner')
    productsQuantity = getters.productsQuantity;
  else {
    getters.orderPdvData.produtos_array.forEach(p => {
      productsQuantity += p.quantidade;
    });
  }
  const orderID = getters.body.codigo_pedido;
  let splitedPayment = 0;
  if (getters.pendingOrder) splitedPayment = getters.partialValue;
  else if (getters.paymentData && getters.paymentData.split_payment)
    splitedPayment = getters.partialValue;
  else splitedPayment = null;
  let params = {
    opt_in: getters.optIn,
    // customer_name: getters.buyerData.name,
    customer_name: getters.userProps.name,
    customer_doc: getters.userProps.document,
    customer_email: getters.userProps.email,
    customer_phone: getters.userProps.phone,
    customer_address: getters.userProps.address,
    customer_address_number: getters.userProps.number,
    customer_address_complement: getters.userProps.complement,
    customer_zipcode: getters.userProps.cep,
    customer_neighborhood: getters.userProps.neighborhood,
    customer_city: getters.userProps.city,
    customer_state: getters.userProps.state,
    customer_country: getters.userProps.country,
    delivery_option_id: getters.deliveryOption,
    event_id: getters.eventID,
    order_id:
      router.history.current.name === 'commissioner'
        ? getters.orderPdvData.codigo_pedido
        : orderID,
    payment_type_id: 9,
    products_amount: productsQuantity,
    total:
      router.history.current.name === 'commissioner'
        ? getters.totalValueOrder * 100
        : getters.productsTotal * 100,
    split_payment_total: splitedPayment,
    // pdv: 100,
    coupon: getters.cupomCode || '',
  };
  if (getters.userProps.email) {
    params.customer_email = getters.userProps.email;
  }

  if (
    (getters.eventName && getters.eventName.includes('Natal Luz')) ||
    getters.checkout_dados_nf === 2
  ) {
    let location =
      getters.userProps && getters.userProps.locationModel
        ? getters.userProps.locationModel.split('/')
        : '';
    params.customer_city = location ? location[0] : '';
    params.customer_state = location ? location[1] : '';
    params.customer_country = location ? location[2] : '';
  }

  if (getters.buyerData.clientID) {
    params.user_id = getters.buyerData.clientID;
  }

  try {
    dispatch('addLoading');
    let headers = { checkout: 'one-checkout' };
    const response = await $http.post('orders/charge/invoice', params, {
      headers,
    });

    const { data } = response;
    commit('SET_ORDER_DATA', data);

    const postOrder = {
      ...getters.postOrder,
      ddi: params.ddi,
      ddd: params.ddd,
      phone: params.phone,
      email: params.customer_email,
      organizador: data.orderData ? data.orderData.nome_organizador : '',
      cpf_organizador: data.orderData ? data.orderData.org_cpf : '',
      cnpj_organizador: data.orderData ? data.orderData.org_cnpj : '',
      mensagem: data.orderData ? data.orderData.mensagem_conclusao_pedido : '',
      status: data.status === 'paid' ? 'Aprovado' : 'Em análise',
      hash_pedido: getters.body.hash_pedido,
      payment: state.paymentOption,
    };

    dispatch('setPostOrder', postOrder);
    dispatch('setBody', {
      ...getters.body,
      expiration: 0,
    });
    // dispatch('confirmOrder');
    console.log('PASSEI AQUI');
    commit('SET_TICKET_URL', data.orderData ? data.orderData.ticketsUrl : '');
    console.log('setPurchaseStarted - chargeCard 332 - false');
    dispatch('setPurchaseStarted', false);
    dispatch('nextStep');

    dispatch('subtractLoading');
  } catch (error) {
    const evento = getters.eventID;
    console.log('error.response', error.response);
    if (error.response && error.response.status === 412) {
      dispatch('openSnackbar', {
        message: error.response.data.message,
      });
    }
    if (error.response && error.response.status === 422) {
      dispatch('openSnackbar', {
        message:
          'Seu pedido foi cancelado por excesso de tentativas de pagamento.',
        extraButton: true,
      });
    }
    if (error.response && error.response.status === 410) {
      dispatch('openSnackbar', {
        message: 'Pedido Inválido',
      });
      dispatch('deleteCheckoutState', evento);
      dispatch('loadCheckoutState', evento);
      dispatch('resetSelection');
      dispatch('setResetPurchase', false);
    }
    dispatch('subtractLoading');
    console.log('setPurchaseStarted - chargeCard 349 - false');
    dispatch('setPurchaseStarted', false);
    console.error(`Failed charging card`, error);
  }
};

export const chargeBillet = async ({ dispatch, commit, getters, state }) => {
  const { productsQuantity } = getters;
  const orderID = getters.body.codigo_pedido;
  let splitedPayment = 0;
  if (getters.pendingOrder) splitedPayment = getters.partialValue;
  else if (getters.paymentData && getters.paymentData.split_payment)
    splitedPayment = getters.partialValue;
  else splitedPayment = null;

  const params = {
    opt_in: getters.optIn,
    customer_name: getters.userProps.name,
    customer_doc: getters.userProps.document,
    customer_email: getters.userProps.email,
    customer_phone: getters.userProps.phone,
    customer_address: getters.userProps.address,
    customer_address_number: getters.userProps.number,
    customer_address_complement: getters.userProps.complement,
    customer_zipcode: getters.userProps.cep,
    customer_neighborhood: getters.userProps.neighborhood,
    customer_city: getters.userProps.city,
    customer_state: getters.userProps.state,
    customer_country: getters.userProps.country,
    payer_doc: getters.userBilletProps.payer_doc,
    payer_name: getters.userBilletProps.payer_name,
    installment_amount: getters.userBilletProps.installmentsBillet,
    event_id: getters.eventID,
    delivery_option_id: getters.deliveryOption,
    order_id:
      router.history.current.name === 'commissioner'
        ? getters.orderPdvData.codigo_pedido
        : orderID,
    payment_type_id: 3, // Boleto
    products_amount: productsQuantity,
    total:
      router.history.current.name === 'commissioner'
        ? getters.totalValueOrder * 100
        : getters.productsTotal * 100,
    split_payment_total: splitedPayment,
    // pdv: 100,
  };

  if (getters.buyerData.clientID) {
    params.user_id = getters.buyerData.clientID;
  }

  if (
    (getters.eventName && getters.eventName.includes('Natal Luz')) ||
    getters.checkout_dados_nf === 2
  ) {
    let location =
      getters.userProps && getters.userProps.locationModel
        ? getters.userProps.locationModel.split('/')
        : '';
    params.customer_city = location ? location[0] : '';
    params.customer_state = location ? location[1] : '';
    params.customer_country = location ? location[2] : '';
  }

  if (getters.buyerData.email) {
    params.customer_email = getters.buyerData.email;
  }

  try {
    dispatch('addLoading');
    let headers = { checkout: 'one-checkout' };
    const response = await $http.post('pdv/orders/charge/billet', params, {
      headers,
    });

    const { data } = response;
    commit('SET_ORDER_DATA', data);
    const postOrder = {
      ...getters.postOrder,
      email: params.customer_email,
      phone: params.customer_phone,
      status:
        data.status === 'waiting_payment'
          ? 'Aguardado Pagamento'
          : 'Processando pagamento',
      billet_due: data.billet_due,
      billet_url: data.billet_url,
      billet_barcode: data.billet_barcode,
      organizador: data.orderData.nome_organizador,
      cpf_organizador: data.orderData.org_cpf,
      cnpj_organizador: data.orderData.org_cnpj,
      payment: state.paymentOption,
    };

    dispatch('setPostOrder', postOrder);
    commit('SET_TICKET_URL', data.orderData.ticketsUrl);
    dispatch('setBody', {
      ...getters.body,
      expiration: 0,
    });
    // dispatch('confirmOrder');
    dispatch('subtractLoading');
    console.log('setPurchaseStarted - chargeBillet 421 - false');
    dispatch('setPurchaseStarted', false);
    dispatch('nextStep');

    return response;
  } catch (error) {
    const evento = getters.eventID;
    if (error.response && error.response.status === 412) {
      dispatch('openSnackbar', {
        message: error.response.data.message,
      });
    }
    if (error.response && error.response.status === 410) {
      dispatch('openSnackbar', {
        message: 'Pedido Inválido',
      });
      dispatch('deleteCheckoutState', evento);
      dispatch('loadCheckoutState', evento);
      dispatch('resetSelection');
      dispatch('setResetPurchase', false);
    }
    dispatch('subtractLoading');
    console.log('setPurchaseStarted - chargeBillet 438 - false');
    dispatch('setPurchaseStarted', false);
    console.error(`Failed charging billet`, error);
  }
};

export const chargeCourtesy = async ({ dispatch, getters }) => {
  dispatch('confirmOrder');
};

export const chargeAme = async ({ dispatch, getters, commit }) => {
  const orderID = getters.body.codigo_pedido;
  const params = {
    customer_name: getters.userProps.name,
    customer_doc: getters.userProps.document,
    customer_email: getters.userProps.email,
    customer_phone: getters.userProps.phone,
    customer_address: getters.userProps.address,
    customer_address_number: getters.userProps.number,
    customer_address_complement: getters.userProps.complement,
    customer_zipcode: getters.userProps.cep,
    customer_neighborhood: getters.userProps.neighborhood,
    customer_city: getters.userProps.city,
    customer_state: getters.userProps.state,
    customer_country: getters.userProps.country,
    delivery_option_id: getters.deliveryOption,
    event_id: getters.eventID,
    order_id:
      router.history.current.name === 'commissioner'
        ? getters.orderPdvData.codigo_pedido
        : orderID,
    // pdv: 100
  };

  if (getters.buyerData.clientID) {
    params.user_id = getters.buyerData.clientID;
  }

  if (
    (getters.eventName && getters.eventName.includes('Natal Luz')) ||
    getters.checkout_dados_nf === 2
  ) {
    let location =
      getters.userProps && getters.userProps.locationModel
        ? getters.userProps.locationModel.split('/')
        : '';
    params.customer_city = location ? location[0] : '';
    params.customer_state = location ? location[1] : '';
    params.customer_country = location ? location[2] : '';
  }

  try {
    dispatch('addLoading');
    let headers = { checkout: 'one-checkout' };
    const response = await $http.post('pdv/orders/charge/digital/ame', params, {
      headers,
    });
    commit('SET_ORDER_DATA', response.data);
    commit('SET_AME_DETAILS', response.data);
    dispatch('subtractLoading');
  } catch (error) {
    const evento = getters.eventID;
    if (error.response && error.response.status === 410) {
      dispatch('openSnackbar', {
        message: 'Pedido Inválido',
      });
      dispatch('deleteCheckoutState', evento);
      dispatch('loadCheckoutState', evento);
      dispatch('resetSelection');
      dispatch('setResetPurchase', false);
    }
    dispatch('subtractLoading');
    console.log('setPurchaseStarted - chargeAme 493 - false');
    dispatch('setPurchaseStarted', false);
    console.error(`Failed charging ame`, error);
  }
};

export const chargePix = async ({ dispatch, getters, commit }) => {
  const orderID = getters.body.codigo_pedido;
  let splitedPayment = 0;
  if (getters.pendingOrder) splitedPayment = getters.partialValue;
  else if (getters.paymentData && getters.paymentData.split_payment)
    splitedPayment = getters.partialValue;
  else splitedPayment = null;
  const params = {
    opt_in: getters.optIn,
    customer_name: getters.userProps.name,
    customer_doc: getters.userProps.document,
    customer_email: getters.userProps.email,
    customer_phone: getters.userProps.phone,
    customer_address: getters.userProps.address,
    customer_address_number: getters.userProps.number,
    customer_address_complement: getters.userProps.complement,
    customer_zipcode: getters.userProps.cep,
    customer_neighborhood: getters.userProps.neighborhood,
    customer_city: getters.userProps.city,
    customer_state: getters.userProps.state,
    customer_country: getters.userProps.country,
    delivery_option_id: getters.deliveryOption,
    event_id: getters.eventID,
    order_id:
      router.history.current.name === 'commissioner'
        ? getters.orderPdvData.codigo_pedido
        : orderID,
    split_payment_total: splitedPayment,
  };

  if (getters.buyerData.clientID) {
    params.user_id = getters.buyerData.clientID;
  }

  if (
    (getters.eventName && getters.eventName.includes('Natal Luz')) ||
    getters.checkout_dados_nf === 2
  ) {
    let location =
      getters.userProps && getters.userProps.locationModel
        ? getters.userProps.locationModel.split('/')
        : '';
    params.customer_city = location ? location[0] : '';
    params.customer_state = location ? location[1] : '';
    params.customer_country = location ? location[2] : '';
  }

  try {
    let headers = { checkout: 'one-checkout' };
    const response = await $http.post('pdv/orders/charge/pix', params, {
      headers,
    });
    commit('SET_ORDER_DATA', response.data);
    commit('SET_PIX_DETAILS', response.data);
  } catch (error) {
    const evento = getters.eventID;
    if (error.response && error.response.status === 412) {
      dispatch('openSnackbar', {
        message: error.response.data.message,
      });
      commit('SET_SECOND_PAYMENT_STEP', false);
      commit('SET_PIX_SELECTED', false);
      commit('SET_PIX_DETAILS', null);
      commit('SET_PIX_ORDER_STATUS', null);
    }
    if (error.response && error.response.status === 410) {
      dispatch('openSnackbar', {
        message: 'Pedido Inválido',
      });
      dispatch('deleteCheckoutState', evento);
      dispatch('loadCheckoutState', evento);
      dispatch('resetSelection');
      dispatch('setResetPurchase', false);
    }
    dispatch('subtractLoading');
    console.log('setPurchaseStarted - chargePix 540 - false');
    dispatch('setPurchaseStarted', false);
    console.error(`Failed charging pix`, error);
  }
};

export const registerPayment = ({ dispatch }, params) => {
  dispatch('addLoading');
  return $http
    .post(
      `pdv/orders/register-payment/${params.event}/${params.order}/${params.tid}`,
      params
    )
    .then(response => {
      dispatch('subtractLoading');
      return response;
    })
    .catch(err => {
      dispatch('subtractLoading');
      console.error(`Failed register payment`, err);
    });
};

export const registerUserEmail = ({ dispatch }, params) => {
  return $http
    .post(`pdv/orders/buyer/info`, params)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.error(`Failed register email`, err);
    });
};

export const paymentTotem = ({ dispatch }, params) => {
  return window
    .VS__StartTef(params)
    .then(response => {
      return response;
    })
    .catch(err => {});
};

export const openAdminTerminal = ({ dispatch }, params) => {
  return window
    .VS_StartAutopagseAdmin({ adminPassword: '825613' })
    .then(response => {
      return response;
    })
    .catch(err => {});
};

export const uploadImageTotem = ({ commit }, params) => {
  return $http
    .post(`http://localhost:3000/config/logo`, params)
    .then(response => {
      return response;
    })
    .catch(err => {});
};

export const printTotem = ({ commit }, params) => {
  return $http
    .post(`http://localhost:3000/print/template`, params)
    .then(response => {
      console.log('Imprimido', response);
      return response;
    })
    .catch(err => {});
};

export const printStatus = ({ commit }, params) => {
  return $http
    .get(`http://localhost:3000/printer/status`)
    .then(response => {
      if (response.data) return response;
    })
    .catch(err => {});
};

export const sendOrderByWhats = ({ commit }, params) => {
  return $http
    .post(`v2/orders/resend/whatsapp`, params)
    .then(response => {
      if (response.data) return response;
    })
    .catch(err => {});
};
